module.exports = __webpack_public_path__ + "img/q.74820fd4.jpg";